import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

export enum PermissionGroupEnum {
  ADMIN = 'ADMIN',
  USER = 'USER',
  DEPO = 'DEPO'
}
export class IPostUserCompanyPermissionsBodyDto {
  userId: number | null;
  companyId: number;
  permissionGroup: PermissionGroupEnum;
}

export class IPatchUserCompanyPermissionsBodyDto {
  companyId: number;
  permissionGroup: PermissionGroupEnum;
}

export class UserCompanyPermission {
  id: number;
  userId: number;
  companyId: number;
  permissionGroup: PermissionGroupEnum;
}

export class IUserCompanyPermissionResponse {
  @Type(() => UserCompanyPermission)
  result: UserCompanyPermission;
}

export class IUserCompanyPermissionListResponse extends IPagination {
  @Type(() => UserCompanyPermission)
  results: UserCompanyPermission[];
}

export class IUserCompanypermissionsQueryDto extends IQueryPaginationDto {
  userId?: string;
  companyId?: string;
}
